var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.03516H16M9 2.03516H6C4.93913 2.03516 3.92172 2.45658 3.17157 3.20673C2.42143 3.95687 2 4.97429 2 6.03516C2 7.09602 2.42143 8.11344 3.17157 8.86358C3.92172 9.61373 4.93913 10.0352 6 10.0352H9M15 2.03516H18C19.0609 2.03516 20.0783 2.45658 20.8284 3.20673C21.5786 3.95687 22 4.97429 22 6.03516C22 7.09602 21.5786 8.11344 20.8284 8.86358C20.0783 9.61373 19.0609 10.0352 18 10.0352H15",
    stroke: "#3586FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationicon);
export default __webpack_public_path__ + "static/media/invitationicon.68c761e163ed9b7a8223baf0f2cafd5d.svg";
export { ForwardRef as ReactComponent };